import React from "react";
import { Link as RouterLink} from 'react-router-dom';
import Tooltip from "@material-ui/core/Tooltip";
import Iconify from './Iconify';



export default function CustomToolbar() {
    return (
        <Tooltip title={"Imprimir Itens"}>
            <RouterLink to="/venda/imprimir" color= 'text.secondary'> 
                <Iconify 
                    icon="fluent:print-20-filled" 
                    width="40px"
                    height="40px"
                />   
            </RouterLink> 
        </Tooltip>
    );
}